import React from 'react'
import { Link } from "react-router-dom";

const SolarElectricalInstallation = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Solar & Electrical Installation</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>Solar & Electrical Installation</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/Installation.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Solar & Electrical Installation Services – Yogesh Solar Energy</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      At Yogesh Solar Energy, we provide reliable, efficient, and cost-effective solar and electrical installation solutions for residential, commercial, and industrial needs. Our mission is to deliver sustainable energy systems that reduce electricity costs while ensuring safety and long-term performance.
                    </p>
                    <h3 className="mb-20">Solar Installation Services</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      We specialize in end-to-end solar solutions designed to help you switch to clean and renewable energy:
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" />On-Grid Solar Systems – Reduce your electricity bills by connecting to the grid</li>
                        <li><i className="far fa-check-double" />  Off-Grid Solar Systems – Ideal for remote areas with no electricity access</li>
                        <li><i className="far fa-check-double" />  Hybrid Solar Systems – Combine solar power with battery backup for uninterrupted energy</li>
                        <li><i className="far fa-check-double" />  Solar Panel Installation – High-quality panels installed with precision</li>
                        <li><i className="far fa-check-double" />  Solar Inverter & Battery Setup – Efficient energy storage and usage</li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default SolarElectricalInstallation